<!--   -->
<div id="carouselExampleControls" class="carousel slide" data-ride="carousel" data-interval="3000">
  <div class="carousel-inner carousel-fix-height">
    <!-- Banner 0 -->
    <div *ngIf="dadosCarrossel[4]?.mostrarBanner" class="carousel-item active carousel-item-custom-width">
      <div class="row h-100">
        <!-- DESKTOP/TABLET:  desktop -->
        <div class="col-md-6 d-none d-sm-flex align-items-center justify-content-center h-100">
          <img [src]="dadosCarrossel[4].aviso" alt="Image" />
        </div>
        <!-- MOBILE:mobile -->
        <div class="col-12 d-flex mt-mobile d-sm-none flex-column align-items-center justify-content-center h-100">
          <img [src]="dadosCarrossel[4].avisoMobile" alt="Image" />
        </div>
      </div>
    </div>

    <!-- Banner 1 -->
    <div class="carousel-item active" *ngIf="dadosCarrossel[0]" style="width: 100.1vw !important">
      <div class="row">
        <div class="col-md-6 order-md-last mt-5">
          <img [src]="dadosCarrossel[0].imageUrlBanner1" alt="Image" />
        </div>
        <div class="col-md-6 mt-div-banner-title-on-mobile">
          <div class="paddig-section-title distanciamento-baixo-section-mobile-banner1" style="padding: 26% 0">
            <div class="icon mb-1 text-center">
              <div class="single-img wow">
                <img
                  class="icone-tablet"
                  width="60px !important"
                  [src]="dadosCarrossel[0].imageIconeBanner1"
                  alt="poligono" />
              </div>
            </div>
            <div class="text-center container">
              <h2 class="title-banner title preto-geia">
                {{ dadosCarrossel[0].titleTextPart1CimaBanner1 }}
                <br />
                {{ dadosCarrossel[0].titleTextPart1BaixoBanner1 }}
              </h2>
              <h2 class="sub-title-banner title">
                {{ dadosCarrossel[0].titleTextPart2Banner1 }}
              </h2>
              <h3 class="desc-tite-banner mt-1 preto-geia" style="line-height: 1.1">
                {{ dadosCarrossel[0].paragraphTextPart1Banner1 }}
                <br />
                {{ dadosCarrossel[0].paragraphTextPart2Banner1 }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Banner 2 -->
    <div class="carousel-item" *ngIf="dadosCarrossel[1]" style="width: 100.1vw !important">
      <div class="row">
        <div class="col-md-6 mt-5">
          <img [src]="dadosCarrossel[1].imageUrlBanner2" alt="Image" />
        </div>
        <div class="col-md-6 mt-div-banner-title-on-mobile">
          <div class="paddig-section-title distanciamento-baixo-section-mobile-banner2" style="padding: 26% 0">
            <div class="icon mb-1 text-center">
              <div class="single-img wow">
                <img
                  class="icone-tablet"
                  width="60px !important"
                  [src]="dadosCarrossel[1].imageIconeBanner2"
                  alt="retangulo" />
              </div>
            </div>
            <div class="text-center container">
              <h2 class="title-banner title preto-geia">
                {{ dadosCarrossel[1].titleTextPart1CimaBanner2 }}
                <br />
                {{ dadosCarrossel[1].titleTextPart1BaixoBanner2 }}
              </h2>
              <h2 class="sub-title-banner title">
                {{ dadosCarrossel[1].titleTextPart2Banner2 }}
              </h2>
              <h3 class="desc-tite-banner mt-1 preto-geia" style="line-height: 1.1">
                {{ dadosCarrossel[1].paragraphTextPart1Banner2 }}
                <br />
                {{ dadosCarrossel[1].paragraphTextPart2Banner2 }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Banner 3 -->
    <div class="carousel-item" *ngIf="dadosCarrossel[2]" style="width: 100.1vw !important">
      <div class="row">
        <div class="col-md-6 mt-5">
          <img [src]="dadosCarrossel[2].imageUrlBanner3" alt="Image" />
        </div>
        <div class="col-md-6 mt-div-banner-title-on-mobile">
          <div
            class="paddig-section-title-banner-tres distanciamento-baixo-section-mobile-banner3"
            style="padding: 51% 0">
            <div class="icon mb-1 text-center">
              <div class="single-img wow">
                <img
                  class="icone-tablet"
                  width="60px !important"
                  [src]="dadosCarrossel[2].imageIconeBanner3"
                  alt="retangulo" />
              </div>
            </div>
            <div class="text-center container">
              <h2 class="title-banner title preto-geia">
                {{ dadosCarrossel[2].titleTextPart1CimaBanner3 }}
                <b>{{ dadosCarrossel[2].titleTextPart1CimaNegritoBanner3 }}</b>
                <br />
                {{ dadosCarrossel[2].titleTextPart1BaixoBanner3 }}
              </h2>
              <h2 class="sub-title-banner title">
                {{ dadosCarrossel[2].titleTextPart2Banner3 }}
              </h2>
              <h3 class="desc-tite-banner mt-1 preto-geia" style="line-height: 1.1">
                <b style="font-weight: 700">{{ dadosCarrossel[2].paragraphTextPart1CimaNegritoBanner3 }}</b>
                {{ dadosCarrossel[2].paragraphTextPart1CimaBanner3 }}
                <br />
                {{ dadosCarrossel[2].paragraphTextPart1BaixoBanner3 }}
              </h3>
              <h3 class="desc-tite-banner mt-1 preto-geia" style="line-height: 1.1">
                <b style="font-weight: 700">{{ dadosCarrossel[2].paragraphTextPart2CimaNegritoBanner3 }}</b>
                {{ dadosCarrossel[2].paragraphTextPart2CimaBanner3 }}
                <br />
                {{ dadosCarrossel[2].paragraphTextPart2CentroBanner3 }}
                <br />
                {{ dadosCarrossel[2].paragraphTextPart2BaixoBanner3 }}
              </h3>
              <div class="form-actions mb-1 mt-2 d-flex justify-content-center align-items-center margin-baixo-section">
                <a [href]="whatsApp" target="_blank">
                  <button
                    id="btnWhatsup"
                    type="button"
                    class="btn distanciamento-btn-whatsaap cursor-pointer btn-round bg-side-bar-geia white btn-min-width box-shadow-4 mr-1 mb-1 custom-whatsapp-button"
                    style="text-align: start; height: 50px">
                    <i
                      class="fa fa-whatsapp whatsapp-icon preto-geia"
                      style="
                        padding: 10px;

                        border-radius: 50%;
                        margin-left: -15px;
                      "></i>
                    <b>
                      Conheça nossas
                      <br />
                      soluções personalizadas
                    </b>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- banner 4 -->

    <!-- Banner 3 imposto Renda-->
    <div
      *ngIf="dadosCarrossel[3]?.mostrarBanner"
      class="carousel-item bg-geia-azul mt-1"
      style="width: 100.1vw !important">
      <div class="row">
        <div class="col-md-6 order-md-last mt-2" style="background-color: #fff">
          <img [src]="dadosCarrossel[3].imgBannerImpostoRenda" alt="Image" />
        </div>
        <div class="col-md-6 mt-div-banner-title-on-mobile" style="background-color: #fff">
          <div class="paddig-section-title" style="padding: 30% 0% 0% 12%">
            <div class="text-center container">
              <h2 style="letter-spacing: 1px !important" class="title-banner color-text text-white">
                {{ dadosCarrossel[3].tituloImpostoRenda }}
              </h2>
              <h2 class="sub-title-banner color-text text-white mt-1">
                {{ dadosCarrossel[3].anoCalendarioImpostoRenda }}
              </h2>
              <h3 class="desc-tite-banner mt-1 mb-2 text-white" style="line-height: normal">
                <p class="text-white color-text desc-tite-banner mt-1">
                  <span [innerHTML]="dadosCarrossel[3].descricacaoImpostoRenda1"></span>
                </p>

                <!-- Seu informe de rendimentos<br />
                já está disponível!* -->
              </h3>
              <button
                type="button"
                class="btn-min-width box-shadow-5 text-white btn mr-1 btn-lg mb-1"
                style="
                  background: #023341;
                  min-width: 22.5rem;
                  min-height: 5rem;
                  border-radius: 0.7rem;
                  font-size: 2rem;
                "
                data-toggle="modal"
                data-target="#modal-historico-financeiro">
                ACESSE AQUI!
              </button>
              <p style="font-size: 1.1em" class="text-white desc-tite-banner mt-1 color-text font-weight-bold">
                {{ dadosCarrossel[3].descricaoImpostoRenda2 }}
                <!-- *Beneficiários da Uniodonto: -->
              </p>

              <p class="text-white color-text desc-tite-banner" style="font-size: 1.1em">
                <span [innerHTML]="dadosCarrossel[3].descricaoImpostoRenda3"></span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>
<!-- <pre>{{dadosCarrossel[4]|json}}</pre> -->
